import {
  RECEIVE_APPROVALS,
  RECEIVE_APPROVALS_COUNT,
  RECEIVE_UPDATE_APPROVAL_STATUS,
  REQUEST_UPDATE_APPROVAL_STATUS,
  RECEIVE_UPDATE_APPROVAL_STATUS_ERROR,
  RECEIVE_APPROVALS_UNAUTHORIZED,
  REQUEST_APPROVALS,
} from '../../ActionsConst';

const initialState = {
  total: 0,
  pendingCount: null,
  items: [],
  isUnauthorized: false,
  isLoading: true,
};

const reduceItems = (items) => items.map((item) => ({ ...item, isHidden: false, isLoading: false }));

const reducePendingCount = (pendingCount) => {
  if (pendingCount === 0) {
    return null;
  }

  if (pendingCount > 99) {
    return '99+';
  }

  return `${pendingCount}`;
};

const reduceApproval = (items, approval, approvalState) => {
  const { id } = approval;
  const approvalIndex = items.findIndex((item) => item.id === id);

  return [
    ...items.slice(0, approvalIndex),
    {
      ...items[approvalIndex],
      ...approvalState,
    },
    ...items.slice(approvalIndex + 1, items.length),
  ];
};

const setApprovalAsHidden = (items, approval) =>
  reduceApproval(items, approval, {
    isHidden: true,
    isLoading: false,
  });

const setApprovalLoadingStatus = (items, approval, isLoading) =>
  reduceApproval(items, approval, {
    isLoading,
  });

const pendingReducer = (state, action) => {
  switch (action.type) {
    case REQUEST_APPROVALS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case RECEIVE_APPROVALS: {
      const { total, items } = action.value;
      return {
        ...state,
        isLoading: false,
        total,
        items: [...state.items, ...reduceItems(items)],
      };
    }
    case RECEIVE_APPROVALS_COUNT: {
      const { pendingCount } = action.value;
      return { ...state, pendingCount: reducePendingCount(pendingCount) };
    }
    case REQUEST_UPDATE_APPROVAL_STATUS: {
      const { approval } = action;
      return {
        ...state,
        items: setApprovalLoadingStatus(state.items, approval, true),
      };
    }
    case RECEIVE_UPDATE_APPROVAL_STATUS: {
      const { approval } = action;
      return {
        ...state,
        items: setApprovalAsHidden(state.items, approval),
        total: state.total - 1,
      };
    }
    case RECEIVE_UPDATE_APPROVAL_STATUS_ERROR: {
      const { approval } = action;
      return {
        ...state,
        items: setApprovalLoadingStatus(state.items, approval, false),
      };
    }
    case RECEIVE_APPROVALS_UNAUTHORIZED: {
      return {
        ...state,
        isUnauthorized: true,
      };
    }
    default:
      return state;
  }
};

const approvalsReducer = (state = initialState, action) => ({ ...state, ...pendingReducer(state, action) });

export default approvalsReducer;
